class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.addedVariantIds = parsedState.addedVariantIds || (parsedState.id ? [parsedState.id] : []);
      this.getSectionsToRender().forEach((section => {
        const target = document.getElementById(section.id);
        const sectionHTML = parsedState.sections && parsedState.sections[section.id];
        if (!target || !sectionHTML) return;

        target.innerHTML = section.id === 'cart-notification-product'
          ? this.getProductItemsHTML(sectionHTML)
          : this.getSectionInnerHTML(sectionHTML, section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return element ? element.innerHTML : '';
  }

  getProductItemsHTML(html) {
    const documentHTML = new DOMParser().parseFromString(html, 'text/html');
    const variantIds = new Set(this.addedVariantIds.map(String));
    const items = Array.from(documentHTML.querySelectorAll('[data-cart-notification-variant]'));
    const matchingItems = items.filter((item) => variantIds.has(item.dataset.cartNotificationVariant));

    if (matchingItems.length) return matchingItems.map((item) => item.outerHTML).join('');

    const legacyItem = documentHTML.querySelector(`#cart-notification-product-${this.productId}`);
    return legacyItem ? legacyItem.outerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
